<div
  class="mc"
  [class.mc-feed]="slot === 'feed'"
  [class.mc-story]="slot === 'story'"
  [class.mc-fullscreen]="slot === 'fullscreen'"
  [class.mc-fit]="slot === 'fit'"
  [class.mc-cover]="slot === 'cover'"
  [class.mc-portrait]="portrait"
  [class.mc-tall]="tall"
>
  <ng-container *ngIf="src; else missing">
    <ng-container *ngIf="asVideo; else still">
      <!-- The backdrop stays on the first frame; a second playing decoder is not worth it. -->
      <video
        *ngIf="slot === 'story' && !tall"
        class="mc-backdrop"
        [muted]="true"
        [src]="src"
        preload="metadata"
        playsinline
        aria-hidden="true"
      ></video>
      <video
        #video
        class="mc-image"
        [muted]="true"
        [src]="src"
        autoplay
        loop
        playsinline
        disablepictureinpicture
        (loadedmetadata)="onVideoMetadata(video)"
        (error)="onVideoError()"
      ></video>
    </ng-container>
    <ng-template #still>
      <img *ngIf="slot === 'story' && !tall" class="mc-backdrop" [src]="src" alt="" aria-hidden="true" />
      <img #image class="mc-image" [src]="src" alt="" (load)="onLoad(image)" />
    </ng-template>
  </ng-container>
  <ng-template #missing>
    <div class="mc-missing">{{ kind === 'video' ? 'Video (1440x1440 or 1440x1800)' : 'Image (1080x1080 or 1080x1920)' }}</div>
  </ng-template>
</div>
